import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
    public static KEY_LOGIN = "login_observable"
    public static KEY_ABERTURA_GRAFICO_ANALISE_ATIVOS = "KEY_ABERTURA_GRAFICO_ANALISE_ATIVOS"
    public static KEY_ABERTURA_GRAFICO_PRISMA = "KEY_ABERTURA_GRAFICO_PRISMA"
    public static KEY_LOGOFF_APP = "KEY_LOGOFF_APP"
    public static KEY_LOGOUT_FOR_INVALID_TOKEN = "KEY_LOGOUT_FOR_INVALID_TOKEN"
    public static KEY_REDIRECT_BY_REFRESH_TOKEN = "KEY_REDIRECT_BY_REFRESH_TOKEN"
    public static KEY_CLIENT_PROSPECT_SELECT_USER_INCOMPLETE_FORM = "KEY_CLIENT_PROSPECT_SELECT_USER_INCOMPLETE_FORM"
    public static KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION = "KEY_CLIENT_PROSPECT_SELECT_OPTION_QUESTION"
    public static KEY_CLIENT_PROSPECT_CONFIRM_LAST_QUESTION = "KEY_CLIENT_PROSPECT_CONFIRM_LAST_QUESTION"
    public static KEY_CLIENT_PROSPECT_SHOW_BACK_BUTTON = "KEY_CLIENT_PROSPECT_SHOW_BACK_BUTTON"
    public static KEY_CLIENT_PROSPECT_HIDE_BACK_BUTTON = "KEY_CLIENT_PROSPECT_HIDE_BACK_BUTTON"


    private static subject = new Subject<any>();

    public static sendMessage(keyObservable: string, message: any = null) {
        this.subject.next({ identifyObservable: keyObservable, message });
    }

    public static clearMessages() {
        this.subject.next();
    }

    public static getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}